module.exports = __webpack_public_path__ + "14a0833cd989a3175a0bff1b83212e16.svg";